export default {
  bibliotecas: [],
  biblioteca: {},
  biblioteca_files: [],
  pagination: {},
  pagination_files: {},
  layout: {},
};
